module.exports = __webpack_public_path__ + "static/img/img-03.5d6b01a2.png";